import { useRouter } from 'next/router';

const useIsEn = () => {
  const { locale } = useRouter();
  const isEn = locale.toLowerCase().includes('en');
  return isEn;
};

export default useIsEn;
